export default "__VITE_ASSET__DRKth4Dx__"